import React, { useEffect, useCallback, useState } from 'react';
import axios from 'axios';
import getUser, { NOT_MODIFIED, MISSING_TOKEN } from '../getUser';
import setCurrentUser from '../setCurrentUser';

const centralApiHost = process.env.CENTRAL_API; // eslint-disable-line no-undef
const defaultRefreshInterval = 30000; // 30 seconds

/**
 * This tracks the current user give the access token.
 *
 * Basically it periodically hits the central `/me` endpoint to get the current
 * user info and uses `If-Modified-Since` to get a 304 if the user has not changed
 */
export default function CurrentUser({ refreshInterval, currentAccessToken, reload }) {
    const refreshUserInterval = refreshInterval || defaultRefreshInterval;
    const [lastModified, setLastModified] = useState(null);

    const refreshUser = useCallback(
        () =>
            getUser(lastModified, reload).then(
                user => {
                    if (user === NOT_MODIFIED) {
                        return;
                    }

                    setCurrentUser(user);
                    if (typeof user.lastModified !== 'undefined') {
                        setLastModified(user.lastModified);
                    }
                },
                error => {
                    if (error === MISSING_TOKEN) {
                        return;
                    }

                    return Promise.reject(error);
                },
            ),
        [lastModified, setLastModified, reload],
    );

    // current access token is imporant here as the effect will fire
    // whenever the token is changed. Like during the login flow.
    useEffect(() => {
        refreshUser();
        let interval = setInterval(refreshUser, refreshUserInterval);
        return () => clearInterval(interval);
    }, [refreshUser, refreshUserInterval, currentAccessToken]);

    return null;
}
